import React from 'react';

/**
 * BadgeGroup component that creates a two-part badge similar to Bulma's tag add-ons
 * 
 * @param {Object} props - Component props
 * @param {string} props.label - Text for the left dark part of the badge
 * @param {string} props.value - Text for the right colored part of the badge
 * @param {string} props.color - Bootstrap color variant (primary, secondary, success, etc.)
 * @param {string} [props.className] - Additional CSS classes
 * @returns {JSX.Element} BadgeGroup component
 */
const BadgeGroup = ({ label, value, color = 'secondary', className = '' }) => {
  return (
    <div className={`badge-group ${className}`}>
      <span className="badge-label">{label}</span>
      <span className={`badge bg-${color}`}>{value}</span>
    </div>
  );
};

export default BadgeGroup;